// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Lufg","colMin":"styles_colMin__8W91v"};